import(/* webpackMode: "eager" */ "E:\\test\\web-site\\app\\layout.tsx")